import { Suspense } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { router } from "@/router";
import "@/styles/globals.css";
import "@/styles/components.css";
import "@/styles/landing-page.css";
import "@/styles/marketing-pages.css";
import "@/styles/image-generator.css";
import "@/styles/image-tool-page.css";
import "@/styles/image-tool-content.css";
import "@/styles/site-sky.css";
import "@/styles/legal-pages.css";
import { bootstrapAuthSession } from "@/auth/authSession";
import { canonicalRedirectUrl } from "@/lib/canonical-host";

window.addEventListener("focus", () => { void bootstrapAuthSession(); });
window.addEventListener("pageshow", (event) => { if (event.persisted) void bootstrapAuthSession(); });

function mount() {
  const root = document.getElementById("root");
  if (!root) throw new Error("Missing #root application mount point");

  createRoot(root).render(
    <Suspense fallback={<div className="studio-route-loading" aria-label="Loading" />}>
      <RouterProvider router={router} />
    </Suspense>,
  );
}

// 命中 www 时先整页换到规范域名，不挂载应用，避免渲染一份马上被替换的页面。
const canonicalTarget = canonicalRedirectUrl(new URL(window.location.href));
if (canonicalTarget) window.location.replace(canonicalTarget);
else {
  // Start restoring the account before React mounts so the shared Header can
  // resolve its Dashboard action while the first route is rendering.
  void bootstrapAuthSession();
  mount();
}
